/**
 *  logAll() 看日志
 *  dismissAll() 屏蔽日志
 * @param args
 */
export function printLog(...args) {
  var _window$logger, _window$logger$info;
  (_window$logger = window.logger) === null || _window$logger === void 0 || (_window$logger$info = _window$logger.info) === null || _window$logger$info === void 0 || _window$logger$info.call(_window$logger, ...args);
}
export function printError(...args) {
  var _window$logger2, _window$logger2$error;
  (_window$logger2 = window.logger) === null || _window$logger2 === void 0 || (_window$logger2$error = _window$logger2.error) === null || _window$logger2$error === void 0 || _window$logger2$error.call(_window$logger2, ...args);
}
//# sourceMappingURL=log.js.map
